import { metaData } from 'config/config';

import { GetUnitsScheduleRequest } from '../api/schedule_grpc_web_pb';
import { ScheduleService } from '../store/services/schedule';

const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

export const getUnitAdjustedGla = (unit) => {
  const adjustedGla = toFiniteNumber(unit?.adjustedGla);

  if (adjustedGla > 0) {
    return adjustedGla;
  }

  const gla = toFiniteNumber(unit?.gla);
  const weightedFactor = toFiniteNumber(unit?.weightedFactor, 1);

  return gla * weightedFactor;
};

export const getUnitsSchedule = (assetId) =>
  new Promise((resolve, reject) => {
    const request = new GetUnitsScheduleRequest();
    request.setAssetid(assetId);

    ScheduleService.getUnitsSchedule(request, metaData(), (err, response) => {
      if (err) {
        reject(err.message);
        return;
      }

      resolve(response.toObject().unitsList ?? []);
    });
  });

export const getAdjustedGlaByAsset = async (assetIds, { occupiedOnly = false } = {}) => {
  const uniqueAssetIds = [...new Set((assetIds ?? []).filter(Boolean))];
  const result = {};

  await Promise.all(
    uniqueAssetIds.map(async (assetId) => {
      const units = await getUnitsSchedule(assetId);
      result[assetId] = units.reduce((sum, unit) => {
        if (occupiedOnly && !unit.tenantid) {
          return sum;
        }

        return sum + getUnitAdjustedGla(unit);
      }, 0);
    })
  );

  return result;
};

export const getAdjustedGlaByTenant = async (assetIds) => {
  const uniqueAssetIds = [...new Set((assetIds ?? []).filter(Boolean))];
  const result = {};

  await Promise.all(
    uniqueAssetIds.map(async (assetId) => {
      const units = await getUnitsSchedule(assetId);

      units.forEach((unit) => {
        if (!unit.tenantid) {
          return;
        }

        result[unit.tenantid] = (result[unit.tenantid] ?? 0) + getUnitAdjustedGla(unit);
      });
    })
  );

  return result;
};

export const calculateMonthlyRentPerAdjustedGla = (monthlyRent, adjustedGla, fallback = 0) => {
  const rent = toFiniteNumber(monthlyRent);
  const area = toFiniteNumber(adjustedGla);

  return area > 0 ? rent / area : fallback;
};
